<template>
	<footer class="bg-dark py-5">
		<div class="container">
			<div class="row justify-content-between">
				<div class="col-md-4 text-center">
					<img width="200px" src="https://hviorder.ca/img/hvi-logo-hvi-white.svg"
					     class="mb-4">
					<p class="text-white-50">
						Copyright © 2021 | Home Value Inc.
						
						We specialize in providing professional residential real estate
						valuation services. Appraisal reports are prepared with the precision
						that the industry demands and cover all major residential property
						types. All of our assignments comply with the Canadian Uniform Standards
						of Professional Appraisal Practice.
					</p>
				</div>
				<div class="col-md-4 text-center text-md-left">
					<h6 class="text-white mb-3">Social Media</h6>
					<nav class="d-flex justify-content-center justify-content-md-start">
						<a href="" class="">
							<i class="fab fa-facebook text-white fa-2x mr-4"></i>
						
						</a>
						<a href="" class="">
							<i class="fab fa-instagram text-white fa-2x mr-4"></i>
						</a>
						<a href="" class="">
							<i class="fab fa-linkedin text-white fa-2x"></i>
						</a>
					
					</nav>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'Footer',
		data () {
			return {}
		}
	}
</script>
